// To match strings ending with REQUEST | SUCCESS | FAILURE
export var requestFlowActionsRegex = /(_REQUEST|_SUCCESS|_FAILURE)$/;
// To match strings ending with REQUEST
export var requestActionRegex = /_REQUEST$/;

//# sourceMappingURL=apiLoading.js.map